// extracted by mini-css-extract-plugin
export default {"divider":"style_divider__biBIM","no-margin-top":"style_no-margin-top__0dyoB","table-container":"style_table-container__kChQE"};